import { FC } from 'react';

const IntroSliderWeb: FC = () => {
  return <></>;
};

export default IntroSliderWeb;
